<div class="chart-container mt-0">
    <canvas  [id]="chartId" >{{ chart }}</canvas>
    <div *ngIf="showOverlay" class="region-overlay opc-1">
        <a href="javascript:void(0)" class="btn-model">Provide spend in the above panel to get the Detailed Tower Analysis.</a>
    </div>
</div>
